import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tooltip']
  static values = {text: String}

  copy() {
    navigator.clipboard.writeText(this.textValue).catch(() => {})

    const tooltip = window.bootstrap.Tooltip.getOrCreateInstance(this.tooltipTarget)
    tooltip.show()

    this.hideTimeout = setTimeout(() => tooltip.hide(), 2000)
  }

  disconnect() {
    clearTimeout(this.hideTimeout)
  }
}
